import { createSelector } from 'reselect';
import get from 'lodash/get';
import {
  graphDataOrEmptyObjectSelector,
  supportDataOrEmptyObjectSelector,
} from '../../../AdvWorkflow/AdvWorkflowSelector';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';

export const nullablePurchaseAtRetirementSelector = createSelector(
  graphDataOrEmptyObjectSelector,
  graphDataOrEmpty =>
    get(graphDataOrEmpty, `${HOME_PURCHASE_GOAL_GRAPH_NODE}.PurchaseAtRetirement`, null),
);

export const nullableDesiredPurchaseYearSelector = createSelector(
  graphDataOrEmptyObjectSelector,
  graphDataOrEmpty =>
    get(graphDataOrEmpty, `${HOME_PURCHASE_GOAL_GRAPH_NODE}.DesiredPurchaseYear`, null),
);

export const yearOptionsOrDefaultSelector = createSelector(
  graphDataOrEmptyObjectSelector,
  (graphData) => {
    const options = get(graphData, 'YearsOptions', null);
    if (options != null) {
      if (graphData.HasRetirementGoal) {
        return ['At Retirement'].concat(options.map(year => `${year}`));
      }
      return options.map(year => `${year}`);
    }
    return [];
  },
);

export const selectedYearOptionOrDefaultSelector = createSelector(
  supportDataOrEmptyObjectSelector,
  supportDataOrEmptyObject =>
    get(supportDataOrEmptyObject, `${HOME_PURCHASE_GOAL_GRAPH_NODE}.YearHomePurchase`, ''),
);

export const selectedYearOptionIsValidSelector = createSelector(
  selectedYearOptionOrDefaultSelector,
  yearOptionsOrDefaultSelector,
  (selectedYearOptionOrDefault, yearOptionsOrDefault) =>
    yearOptionsOrDefault.findIndex(yearOption => yearOption === selectedYearOptionOrDefault) !== -1,
);

export const yearHomePurchaseOrDefaultSelector = createSelector(
  nullablePurchaseAtRetirementSelector,
  nullableDesiredPurchaseYearSelector,
  (nullablePurchaseAtRetirement, nullableDesiredPurchaseYear) => {
    if (nullablePurchaseAtRetirement === null) {
      return '-';
    }
    if (nullablePurchaseAtRetirement) {
      return 'At Retirement';
    }

    if (nullableDesiredPurchaseYear === null) {
      return '-';
    }
    return `${nullableDesiredPurchaseYear}`;
  },
);
